var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,4a12,12,0,1,0,12,12A12,12,0,0,0,16.22,4Zm0,3.5a5.75,5.75,0,1,1-5.75,5.75A5.76,5.76,0,0,1,16.22,7.5Zm0,18.5a10,10,0,0,1-8-4,18.69,18.69,0,0,1,8-2,18.73,18.73,0,0,1,8,2A10,10,0,0,1,16.22,26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookUser);
export default __webpack_public_path__ + "static/media/facebook-user.ede622d2.svg";
export { ForwardRef as ReactComponent };